import { EventEmitter, Injectable, Input, Output } from "@angular/core";
import { MixinInjectorConstructor } from "./mixin";

export const FieldSuffixMixin = <CLAZZ extends MixinInjectorConstructor>(Clazz: CLAZZ) => {
  @Injectable()
  abstract class FieldIcon extends Clazz {
    @Input() fieldSuffix: string = null;

    @Output()
    public fieldSuffixChange = new EventEmitter<string>();
  }

  return FieldIcon;
};

export const FieldSuffixMixinInputs = ["fieldSuffix"];
